







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment'
import AMSTable from '@/components/AMSTable.vue'

@Component({
  components: {
    'ams-table': AMSTable
  }
})
export default class AMSOperateLogs extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return new Array();
    }
  })
  logs!: any[] | undefined;
  @Prop({ default: true }) showLogType!: boolean;
  @Prop({ default: false }) disCountDesc!: boolean;

  flexCss = true;
  keyIndex: string = '';
  headers = [
        {
          // '操作者'
          text: '操作者',
          value: 'operator',
          width: 150,
          align: 'left'
        },
        {
          // '操作时间'
          text: '操作时间',
          width: 180,
          align: 'left',
          value: 'OperateTime',
          render: (h: Function, params: any) => {
            return h(
              'div',
              moment(params.row.operateTime).format('YYYY-MM-DD HH:mm:ss')
            )
          }
        },
        {
          // '操作类型'
          text: '操作类型',
          value: 'operateType',
          width: 150,
          align: 'left'
        },
        {
          // '说明'#00a679
          text: '说明',
          value: 'propetyChanges',
          type: 'html',
          render: (h: Function, params: any) => {
            let text = ''
            if (this.disCountDesc) { // 折扣的操作记录说明样式有区分
              params.row.propetyChanges.forEach((item: any) => {
                if (item.originalValue.indexOf('br') >= 0 || item.newValue.indexOf('br') >= 0) {
                  text += `<div style="display:flex">原&nbsp;${item.propertyName}&nbsp;由&nbsp;`+
                  `<div style="color:#00a679" >${item.originalValue ? item.originalValue : '空'}</div>`+
                  `&nbsp;修改为&nbsp;<div style="color:red" > ${item.newValue ? item.newValue : '空'} &nbsp;</div></div>`
                } else {
                  text += `<div style="display:flex">原 ${item.propertyName} 由&nbsp;<span style="color:#00a679">${item.originalValue ? item.originalValue : '空'}</span> `+
                    `&nbsp;修改为&nbsp;<span style="color:red">${item.newValue ? item.newValue : '空'}</span></div>`
                }
              })
            } else {
              params.row.propetyChanges.forEach((item: any) => {
                text += `<div style="display:flex">原 ${item.propertyName} 由&nbsp;<span style="color:#00a679">${item.originalValue ? item.originalValue : '空'}</span> `+
                    `&nbsp;修改为&nbsp;<span style="color:red">${item.newValue ? item.newValue : '空'}</span></div>`
              })
            }
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }
  ];
  noOperateType = [
        {
          // '操作者'
          text: '操作者',
          value: 'operator',
          width: 150
        },
        {
          // '操作时间'
          text: '操作时间',
          width: 180,
          value: 'OperateTime',
          render: (h: Function, params: any) => {
            return h(
              'div',
              moment(params.row.operateTime).format('YYYY-MM-DD HH:mm:ss')
            )
          }
        },
        {
          // '说明'
          text: '说明',
          value: 'propetyChanges',
          type: 'html',
          render: (h: Function, params: any) => {
            let text = ''
            if (this.disCountDesc) { // 折扣的操作记录说明样式有区分
              params.row.propetyChanges.forEach((item: any) => {
                if (item.originalValue.indexOf('br') >= 0 || item.newValue.indexOf('br') >= 0) {
                  text += `<div style="display:flex">原&nbsp;${item.propertyName}&nbsp;由&nbsp;`+
                  `<div style="color:#00a679" >${item.originalValue ? item.originalValue : '空'}&nbsp;</div>`+
                  `修改为&nbsp;<div style="color:red" > ${item.newValue ? item.newValue : '空'} &nbsp;</div></div>`
                } else {
                  text += `<div style="display:flex">原 ${item.propertyName} 由 <span style="color:#00a679">${item.originalValue ? item.originalValue : '空'}</span>`+
                    `&nbsp;修改为&nbsp;<span style="color:red">${item.newValue ? item.newValue : '空'}</span></div>`
                }
              })
            } else {
              params.row.propetyChanges.forEach((item: any) => {
                text += `<div style="display:flex">原 ${item.propertyName} 由 <span style="color:#00a679">${item.originalValue ? item.originalValue : '空'}</span>`+
                    `&nbsp;修改为&nbsp;<span style="color:red">${item.newValue ? item.newValue : '空'}</span></div>`
              })
            }
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }
  ];
}
